import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './LoadingConfig.Styles';

const balanceLoadingConfig = [
  {
    main: setLoadingConfigObject('line', 1, '95%', styles.divider),
  },
  {
    main: setLoadingConfigObject('line', 1, '20%', styles.secondSectionLineStyle),
  },
  {
    main: setLoadingConfigObject('line', 1, '95%', styles.divider),
  },
  {
    left: setLoadingConfigObject('circle', 1, null, styles.thirdSectionCircleStyle),
    main: [
      setLoadingConfigObject('line', 1, '67%', styles.thirdSectionLineStyle),
      setLoadingConfigObject('line', 1, '27%', styles.thirdSectionLineStyle),
    ],
    right: setLoadingConfigObject('square', 2, null, styles.thirdSectionSquareStyle),
    style: styles.thirdSectionStyle,
  },
  {
    left: setLoadingConfigObject('circle', 1, null, styles.thirdSectionCircleStyle),
    main: [
      setLoadingConfigObject('line', 1, '67%', styles.thirdSectionLineStyle),
      setLoadingConfigObject('line', 1, '27%', styles.thirdSectionLineStyle),
    ],
    right: setLoadingConfigObject('square', 2, null, styles.thirdSectionSquareStyle),
    style: styles.thirdSectionStyle,
  },
  {
    left: setLoadingConfigObject('circle', 1, null, styles.thirdSectionCircleStyle),
    main: [
      setLoadingConfigObject('line', 1, '67%', styles.thirdSectionLineStyle),
      setLoadingConfigObject('line', 1, '27%', styles.thirdSectionLineStyle),
    ],
    right: setLoadingConfigObject('square', 2, null, styles.thirdSectionSquareStyle),
    style: styles.thirdSectionStyle,
  },
];
export { balanceLoadingConfig, shimmerPlaceholderConfig };
